import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/navBar';
import HouseIcon from '../images/cny-house.svg';
import CNYCNLogo from '../images/cny-logo-nav.svg';
import ContactIcon from '../images/contact-icon.svg';
import AboutIcon from '../images/about-icon.svg';
import IntroductionIcon from '../images/introduction-icon-new.svg';

const NavBar = ({ navLocation, toggleContact, toggleAbout }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(!expanded);
  const renderPillars = () => (
    Locale.pillars.map((pillar, idx) => (
      <a
        key={pillar.key}
        href={`#${pillar.key}`}
        className={navLocation === (idx + 1) ? 'selected' : ''}
      >
        <span className="nav-bar-abbreviation">{idx + 1}</span>
        <span>{pillar.title}</span>
      </a>
    ))
  );

  return (
    <div
      className={`nav-bar${expanded ? ' expanded' : ''}`}
      onMouseEnter={toggleExpanded}
      onMouseLeave={toggleExpanded}
    >
      <div className="nav-links">
        <a
          href="#top"
          className="nav-link nav-bar-top"
        >
          <span className="nav-bar-abbreviation">
            <img src={expanded ? CNYCNLogo : HouseIcon} alt="CNYCN logo" />
          </span>
        </a>
        <a
          href="#introduction"
          className={`nav-link introduction${navLocation === 0 ? ' selected' : ''}`}
        >
          <span className="nav-bar-abbreviation">
            <img src={IntroductionIcon} alt="introduction icon" />
          </span>
          <span>{Locale.intro}</span>
        </a>
        {renderPillars()}
        <button className="nav-link about" onClick={toggleAbout} type="button">
          <span className="nav-bar-abbreviation">
            <img src={AboutIcon} alt="about icon" />
          </span>
          <span>{Locale.about}</span>
        </button>
        <button onClick={toggleContact} className="nav-link contact" type="button">
          <span className="nav-bar-abbreviation">
            <img src={ContactIcon} alt="contact icon" />
          </span>
          <span>{Locale.contact}</span>
        </button>
      </div>
    </div>
  );
};

NavBar.propTypes = {
  navLocation: PropTypes.number,
  toggleContact: PropTypes.func.isRequired,
  toggleAbout: PropTypes.func.isRequired
};

NavBar.defaultProps = {
  navLocation: null
};

export default NavBar;
